module.exports = __webpack_public_path__ + "static/img/5.7be9e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/5.png
// module id = 8v5i
// module chunks = 0